import {HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {Router} from "@angular/router";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";

export const IGNORE_403_ERROR = new HttpContextToken<boolean>(() => false);

export function http403Interceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
    const router = inject(Router);

    if (req.context.get(IGNORE_403_ERROR)) {
        return next(req)
    }
    return next(req).pipe(tap(event => {
    }, err => {
        handleError(err, router);
    }));
}

function handleError(err: HttpErrorResponse, router: Router) {
    if (err.status == 403) {
        router.navigate(['/error/403']);
    }
}
